import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MainTabBasePathEnum } from '../enums/main-tabs';
import { MultipleResultsPageModule } from '../misc/pages/multiple-results/multiple-results.module';
import { ProfilePageModule } from '../misc/pages/profile/profile.module';
import { ShareContactInfoPageModule } from '../misc/pages/share-contact-info/share-contact-info.module';
import { WalkingFarmModule } from '../misc/pages/walking-farm/walking-farm.module';
import { MapResolver } from '../misc/resolvers/map.resolver';
import { AdvancedPageModule } from './advanced/advanced.module';
import { CameraPageModule } from './camera/camera.module';
import { HistoryPageModule } from './history/history.module';
import { HomePageModule } from './home/home.module';
import { OwnerPageModule } from './owner/owner.module';
import { ParcelNumberPageModule } from './parcel-number/parcel-number.module';

const routes: Routes = [
  {
    loadChildren: () => HomePageModule,
    path: ''
  },
  {
    data: {
      defaultBackHref: MainTabBasePathEnum.PropertySearch
    },
    loadChildren: () => ProfilePageModule,
    path: 'profile'
  },
  {
    data: {
      defaultBackHref: MainTabBasePathEnum.PropertySearch
    },
    loadChildren: () => MultipleResultsPageModule,
    path: 'multiple-results'
  },
  {
    loadChildren: () => OwnerPageModule,
    path: 'owner'
  },
  {
    loadChildren: () => ParcelNumberPageModule,
    path: 'parcel-number'
  },
  {
    loadChildren: () => CameraPageModule,
    path: 'camera'
  },
  {
    loadChildren: () => AdvancedPageModule,
    path: 'advanced'
  },
  {
    loadChildren: () => HistoryPageModule,
    path: 'history'
  },
  {
    loadChildren: () => ShareContactInfoPageModule,
    path: 'share-contact-info'
  },
  {
    data: {
      defaultBackHref: MainTabBasePathEnum.PropertySearch
    },
    loadChildren: () => WalkingFarmModule,
    path: 'walking-farm',
    resolve: {
      map: MapResolver
    }
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class PropertySearchRoutingModule {}
